import React, {useEffect, useMemo, useState} from 'react';
import {useAuth} from '../../../helpers/AuthContext';
import ContentEditor from './ContentEditor';
import createContentApi from './contentApi';

export default function ContentEditorDemo({apiClient}) {
    const auth = useAuth();
    const api = useMemo(
        () => apiClient || createContentApi({fetch: auth.fetch, apiUrl: auth.API_URL}),
        [apiClient, auth.API_URL, auth.fetch],
    );
    const [content, setContent] = useState([]);
    const [selection, setSelection] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        let active = true;
        Promise.all([api.list('page', 1, 100), api.list('blog', 1, 100)])
            .then(([pages, blogs]) => {
                if (!active) return;
                setContent([
                    ...pages.data.map(item => ({...item, kind: 'page'})),
                    ...blogs.data.map(item => ({...item, kind: 'blog'})),
                ]);
            })
            .catch(nextError => {
                if (active) setError(nextError.message);
            })
            .finally(() => {
                if (active) setLoading(false);
            });
        return () => { active = false; };
    }, [api]);

    const selected = content.find(item => `${item.kind}:${item.uuid}` === selection);

    return <section id="content-editor-demo">
        <h2>Page and Blog Editor (React Demo)</h2>
        <div className="content">
            <p>Select real content owned by this seller. The production editor and seller API are
                mounted below; saves affect the selected draft.</p>
            {error && <p className="flash error" role="alert">{error}</p>}
            {loading ? <p role="status">Loading seller content…</p> : <>
                <label htmlFor="content-demo-picker">Content</label>
                <select id="content-demo-picker" value={selection}
                    onChange={event => setSelection(event.target.value)}>
                    <option value="">Choose a page or blog post</option>
                    {content.map(item => <option key={`${item.kind}:${item.uuid}`}
                        value={`${item.kind}:${item.uuid}`}>
                        {item.kind === 'blog' ? 'Blog' : 'Page'}: {item.title}
                    </option>)}
                </select>
            </>}
            {selected && <ContentEditor
                apiClient={api}
                contentUuid={selected.uuid}
                kind={selected.kind}
                backUrl="/account/bktestpage#content-editor-demo"
                classicUrl={
                    `/account/${selected.kind === 'blog' ? 'blog' : 'pages'}/${selected.uuid}`
                }
            />}
        </div>
    </section>;
}
